module.exports = __webpack_public_path__ + "png/quick-registration-dice-1.png?d40a1e135ba4d2555a3e653518cf49a6";